<section class="whitelist-panel">
  <header class="whitelist-panel__header">
    <div class="whitelist-panel__heading">
      <h2 class="whitelist-panel__title">Whitelist</h2>
      <p class="whitelist-panel__subtitle">
        The networks allowed at each location. Open a location to manage the IP
        ranges configured for it.
      </p>
      <div class="whitelist-panel__stats" *ngIf="!isLoading && locations.length">
        <span class="whitelist-stat">
          <strong>{{ locations.length }}</strong>
          {{ locations.length === 1 ? "location" : "locations" }}
        </span>
      </div>
    </div>

    <div class="whitelist-panel__tools" *ngIf="locations.length > 1">
      <div class="whitelist-search">
        <i class="material-icons whitelist-search__icon">search</i>
        <input
          type="text"
          class="whitelist-search__input"
          placeholder="Search by name, city or country"
          aria-label="Search locations"
          [(ngModel)]="searchTerm"
        />
        <button
          type="button"
          class="whitelist-search__clear"
          *ngIf="searchTerm"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
  </header>

  <div class="whitelist-list" *ngIf="!isLoading">
    <article
      class="whitelist-row"
      *ngFor="let location of filteredLocations; trackBy: trackByLocationId"
    >
      <div class="whitelist-row__identity">
        <div
          class="whitelist-tile"
          [ngClass]="'whitelist-tile--tone-' + tileTone(location)"
          aria-hidden="true"
        >
          <i class="material-icons">lan</i>
        </div>
        <div class="whitelist-identity">
          <p class="whitelist-name">{{ location.name }}</p>
          <p class="whitelist-meta">
            <ng-container *ngIf="regionLabel(location); else noRegion">
              <i class="material-icons whitelist-meta__icon">public</i>
              {{ regionLabel(location) }}
            </ng-container>
            <ng-template #noRegion>
              <span class="whitelist-meta__empty">No region set</span>
            </ng-template>
          </p>
        </div>
      </div>

      <div class="whitelist-row__actions">
        <button
          mat-stroked-button
          type="button"
          class="whitelist-manage"
          (click)="openWhitelistDialog(location)"
        >
          <i class="material-icons">settings_ethernet</i>
          <span>Manage networks</span>
        </button>
      </div>
    </article>

    <div class="whitelist-empty" *ngIf="!locations.length">
      <i class="material-icons whitelist-empty__icon">lan</i>
      <p class="whitelist-empty__title">No locations yet</p>
      <p class="whitelist-empty__text">
        Add a location first — network rules are configured per location.
      </p>
    </div>

    <div class="whitelist-empty" *ngIf="locations.length && !filteredLocations.length">
      <i class="material-icons whitelist-empty__icon">search_off</i>
      <p class="whitelist-empty__title">No locations match “{{ searchTerm }}”</p>
      <p class="whitelist-empty__text">Try a different name, city or country.</p>
      <button type="button" class="whitelist-empty__link" (click)="clearSearch()">
        Clear search
      </button>
    </div>
  </div>

  <div class="whitelist-list whitelist-list--loading" *ngIf="isLoading" aria-busy="true">
    <div class="whitelist-skeleton" *ngFor="let placeholder of skeletonRows">
      <div class="skeleton skeleton--tile"></div>
      <div class="whitelist-skeleton__lines">
        <div class="skeleton skeleton--line skeleton--line-lg"></div>
        <div class="skeleton skeleton--line skeleton--line-sm"></div>
      </div>
      <div class="skeleton skeleton--action"></div>
    </div>
  </div>
</section>
